export { default } from './landing-force-vis';
